import { Box, Typography } from '@mui/material'

function Drafts() {
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
      <Typography>Drafts Page</Typography>
    </Box>
  )
}

export default Drafts
